import React from 'react';
import PropTypes from 'prop-types';

export default class SimpleSideBySideNav extends React.Component {

    static propTypes = {
        onLeftClick: PropTypes.func.isRequired,
        onRightClick: PropTypes.func.isRequired,
        leftIcon: PropTypes.node,
        middleElement: PropTypes.node,
        rightIcon: PropTypes.node,
        leftDisabled: PropTypes.bool,
        rightDisabled: PropTypes.bool,
        heightStyle: PropTypes.string, // applied to all elements, children and parent
        iconWidthStyle: PropTypes.string, // width of nav buttons
    };

    static defaultProps = {
        leftIcon:
            <i className="material-icons">
                arrow_back_ios_icon
            </i>, // the "ios" icons are bigger/preferred size
        middleElement: null,
        rightIcon:
            <i className="material-icons">
                arrow_forward_ios_icon
            </i>,
        heightStyle: 'inherit',
    };

    render() {
        const {
            leftIcon,
            middleElement,
            rightIcon,
            heightStyle,
            iconWidthStyle,
            leftDisabled,
            rightDisabled
        } = this.props;

        return (
            <>
            <style>
                {`
                .simple-side-by-side-nav > button > svg {
                    height: ${heightStyle ? heightStyle : 'inherit'};
                    max-height: ${heightStyle ? heightStyle : 'inherit'};
                    width: ${iconWidthStyle ? iconWidthStyle : 'auto'};
                }
                .simple-side-by-side-nav > button {
                    margin: 0 1px;
                }
                .simple-side-by-side-nav > button:disabled {
                    opacity: 0.5;
                    cursor: auto;
                }
                `}
            </style>
            <span
                style={{
                    height: heightStyle ? heightStyle : 'inherit',
                    maxHeight: heightStyle ? heightStyle : 'inherit' }}
                className="simple-side-by-side-nav"
            >
                <button
                    className="simple-side-by-side-nav-left-button"
                    style={{
                        height: heightStyle ? heightStyle : 'inherit',
                        maxHeight: heightStyle ? heightStyle : 'inherit',
                        width: iconWidthStyle ? iconWidthStyle : 'auto',
                    }}
                    disabled={leftDisabled} onClick={() => this.props.onLeftClick()}>
                    {leftIcon}
                </button>
                {middleElement}
                <button
                    className="simple-side-by-side-nav-right-button"
                    style={{
                        height: heightStyle ? heightStyle : 'inherit',
                        maxHeight: heightStyle ? heightStyle : 'inherit',
                        width: iconWidthStyle ? iconWidthStyle : 'auto',
                    }}
                    disabled={rightDisabled} onClick={() => this.props.onRightClick()}>
                    {rightIcon}
                </button>
            </span>
            </>
        );
    }
}